module.exports = __webpack_public_path__ + "static/media/screenshot22.ec8d1016.png";